import React, { useState, useEffect } from 'react';
import { ReptoolModal } from './ReptoolModal.tsx';
import { Button, Badge } from 'react-bootstrap';
import { BasicFetch } from '../../utils/BasicFetch.ts';
import { Roadmap } from '../../types/Roadmap.ts';
import { Col, ListGroupItem, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faStar } from '@fortawesome/free-solid-svg-icons';
import { Carousel } from 'react-responsive-carousel';
import { useRepToolContext } from '../../RepToolContext.tsx';

const NavItem = ({ item, setActiveRoadmap }: {
  item: Roadmap,
  setActiveRoadmap: (item: Roadmap) => void,
}) => {
  const textColor = item.voted ? 'light' : 'secondary';
  return (
    <ListGroupItem className='bg-dark mt-2 d-flex justify-content-between rounded' onClick={() => setActiveRoadmap(item)}>
      <div className='d-flex flex-column flex-fill'>
        <h6 className={`text-light ${item.finished && 'text-decoration-line-through'}`}>{item.title}</h6>
        {item.finished && <Badge bg='success'>Finished</Badge>}
      </div>
      <div className={`text-right text-${textColor} my-auto ml-3`}>
        <FontAwesomeIcon size='xl' icon={faStar} />
      </div>
    </ListGroupItem>
  )
}


export const RoadmapModal = ({ closeModal }: {
  closeModal: () => void,
}) => {
  const [roadmap, setRoadmap] = useState<Roadmap[]>([]);
  const [activeRoadmap, setActiveRoadmap] = useState<Roadmap | null>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const { appendControls } = useRepToolContext();

  const getRoadmaps = () => {
    BasicFetch({
      url: `${(window as any).serverLocation}roadmap/get`,
      method: 'GET',
      onSuccess: ({ items }) => {
        setRoadmap(items);
        setActiveRoadmap(items.find(item => item.id === activeRoadmap?.id) || null);
      }
    })
  }

  const vote = (item: Roadmap) => {
    BasicFetch({
      url: `${(window as any).serverLocation}roadmap/${item.id}/vote`,
      method: 'POST',
      onSuccess: () => {
        getRoadmaps();
      }
    })
  }

  const removeVote = (item: Roadmap) => {
    BasicFetch({
      url: `${(window as any).serverLocation}roadmap/${item.id}/cancel_vote`,
      method: 'POST',
      onSuccess: () => {
        getRoadmaps();
      }
    })
  }


  useEffect(() => {
    getRoadmaps();
    appendControls(null, 'Roadmap Modal');
  }, [])

  return (
    <ReptoolModal title="RepTool Roadmap" closeModal={() => closeModal()} body={
      <>
        <p className='text-light'>Below is a list of features I'm planning to build for RepTool. While all of them are coming soon, I'd love for you to vote on which ones you'd like to see first! Be sure to check back from time to time to let your opinion be heard!</p>


        <div className='d-none d-lg-block'>
          <Row>
            <Col md={4}>
              {
                roadmap.map(item => (
                  <NavItem key={item.id} item={item} setActiveRoadmap={setActiveRoadmap} />
                ))
              }
            </Col>
            <Col md={8}>
              {
                activeRoadmap &&
                <div className='text-light'>
                  <h3 className='border-bottom pb-2'>{activeRoadmap.title}</h3>
                  <div className='p-3'>
                    <p style={{ whiteSpace: "pre-line" }}>{activeRoadmap.body}</p>
                  </div>
                  <div className='d-flex justify-content-center'>
                    {!activeRoadmap.voted ? <Button onClick={() => vote(activeRoadmap)} className='mt-3 mx-auto'>
                      I want this!
                    </Button> : <Button onClick={() => removeVote(activeRoadmap)} variant='secondary' className='mt-3 mx-auto'>
                      I'm no longer interested
                    </Button>}
                  </div>
                </div>
              }
            </Col>
          </Row>
        </div>
        <div className='d-lg-none'>
          <Carousel
            selectedItem={activeIndex}
            onChange={index => setActiveIndex(index)}
            showArrows={false}
            showStatus={false}
            showThumbs={false}
            showIndicators={false}
            swipeable={false}
          >
            <div>
              {
                roadmap.map(item => (
                  <NavItem key={item.id} item={item} setActiveRoadmap={() => {
                    setActiveRoadmap(item);
                    setActiveIndex(1);
                  }} />
                ))
              }
            </div>
            <div className='overflow-auto' style={{
              maxHeight: 'calc(100vh - 80px)',
            }}>
              <div className='d-flex flex-row justify-content-between border-bottom mb-4'>
                <FontAwesomeIcon size='lg' icon={faChevronLeft} onClick={() => { setActiveIndex(0) }} className='mr-3 my-auto' />
                <h3 className='flex-fill text-center'>{activeRoadmap?.title || ''}</h3>
              </div>
              <div className='p-3'>
                <p className='pb-4 text-left' style={{ whiteSpace: "pre-line" }}>{activeRoadmap?.body || ''}</p>
              </div>
              {activeRoadmap && <div className='d-flex justify-content-center'>
                {!activeRoadmap.voted ? <Button onClick={() => vote(activeRoadmap)} className='mt-3 mx-auto'>
                  I want this!
                </Button> : <Button onClick={() => removeVote(activeRoadmap)} variant='secondary' className='mt-3 mx-auto'>
                  I'm no longer interested
                </Button>}
              </div>}
            </div>
          </Carousel>
        </div>
      </>

    } />
  )
}